<div class="fab-overlay" [class.active]="isToggleOpen" (click)="isToggleOpen && isToggleOpen = false" role="button"  tabindex="-1">
     <div class="bubble-container" [class.active]="isToggleOpen" (click)="$event.stopPropagation()" role="button"  tabindex="-1">

    <div class="mini-bubbles" [class.open]="isToggleOpen" *ngIf="isToggleOpen">
       <a
        class="mini-bubble"
         (click)="openFile()"
      >
        <div class="icon"><i class="fi fi-rr-file mt-1"></i><i class="fi fi-sr-add"></i></div>
        <small class="label">{{ 'mobile-status.file' | translate }}</small></a>

      <a
        class="mini-bubble"
         (click)="openLink('case')"
      >
        <div class="icon"><i class="fi fi-rr-ambulance mt-1"></i><i class="fi fi-sr-add"></i></div>
        <small class="label">{{ 'mobile-status.case' | translate }}</small></a>
       <a
        class="mini-bubble"
         (click)="openCaseSummary()"
      >
         <div class="icon"><i class="fi fi-rr-ambulance mt-1"></i><i class="fi fi-sr-add"></i></div>
           <small class="label">{{ 'mobile-status.case-summary' | translate }}</small></a>
      <a
        class="mini-bubble"
         (click)="openLink('appointment')"
      >
        <div class="icon"><i class="fi fi-rr-calendar-lines mt-1"></i><i class="fi fi-sr-add"></i></div>
        <small class="label">{{ 'mobile-status.appointment_label' | translate }}</small>

      </a>
      <a class="mini-bubble" (click)="createOrganization()"
      >
        <div class="icon"><i class="fi fi-rr-calendar-clock mt-1"></i><i class="fi fi-sr-add"></i></div>
        <small class="label">{{ 'mobile-status.organization_label' | translate }}</small>
      </a>

      <a class="mini-bubble" (click)="createPatient()"
      >
        <div class="icon"><i class="fi fi-rr-user mt-1"></i><i class="fi fi-sr-add"></i></div>
        <small class="label">{{ 'mobile-status.patient' | translate }}</small>
      </a>

      <a class="mini-bubble" (click)="openLink('watch')"
      >
        <div class="icon"><i class="fi fi-rr-clock mt-1"></i><i class="fi fi-sr-add"></i></div>
        <small class="label">{{ 'mobile-status.watch' | translate }}</small>
      </a>

      <a class="mini-bubble" (click)="createMedicalAdviceDialog()"
      >
        <div class="icon"><i class="fi fi-rr-user-headset mt-1"></i><i class="fi fi-sr-add"></i></div>
        <small class="label">{{ 'mobile-status.support' | translate }}</small>
      </a>


      <a class="mini-bubble" (click)="createPriceInfo()"
      >
        <div class="icon"><i class="fi fi-rr-qrcode-information mt-1"></i><i class="fi fi-sr-add"></i></div>
        <small class="label">{{ 'mobile-status.info' | translate }}</small>
      </a>

      <a class="mini-bubble" (click)="createWork()"
      >
        <div class="icon"><i class="fi fi-rr-rectangle-history-circle-plus mt-1"></i><i class="fi fi-sr-add"></i
        ></div>
        <small class="label">{{ 'mobile-status.work' | translate }}</small></a>
    </div>
  </div>
</div>

<ng-template #orgCreate></ng-template>
<ng-template #patientCreate></ng-template>
<ng-template #medicalAdviceDialog></ng-template>
<ng-template #priceInfoCreate></ng-template>
<ng-template #workCreate></ng-template>
<ng-template #caseCreate></ng-template>
<ng-template #fileCreate></ng-template>